module.exports = __webpack_public_path__ + "static/img/cpfuss.e49b2f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cpfuss.png
// module id = +5Yn
// module chunks = 0